// extracted by mini-css-extract-plugin
export default {"container":"Form_container__WXj-7","ul":"Form_ul__cb8mS","li":"Form_li__1WBK3","btn":"Form_btn__0ebGo","p":"Form_p__Xydc0","link":"Form_link__fzlRv"};